import { useContext, createContext } from 'react';

export const FormContext = createContext<any>({
  fields: {},
  errors: {},
});

export const useFormContext = () => useContext(FormContext);
